import TilesWrapper from './TilesWrapper';
import './TilesWrapper.scss';

export default TilesWrapper;